import { render, staticRenderFns } from "./VerifyBrokerAccount.vue?vue&type=template&id=b0975b2c&scoped=true"
import script from "./VerifyBrokerAccount.vue?vue&type=script&lang=js"
export * from "./VerifyBrokerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0975b2c",
  null
  
)

export default component.exports